import { useAccountEffect } from 'wagmi'
import { Button } from '@/ui/atoms/button/Button'
import { Typography } from '@/ui/atoms/typography/Typography'
import { ErrorLayout } from '@/ui/layouts/ErrorLayout'
import { useRouter } from 'next/navigation'
import { usePrivy } from '@privy-io/react-auth'
import { Panel } from '@/ui/atoms/panel/Panel'

export function NotConnected({ fullScreen }: { fullScreen?: boolean }) {
  const { connectWallet } = usePrivy()

  const router = useRouter()

  useAccountEffect({
    onConnect: () => {
      router.refresh()
    },
  })

  return (
    <ErrorLayout fullScreen={fullScreen}>
      <Panel.Wrapper className="w-full max-w-xl p-6 text-center">
        <div className="flex flex-col items-center justify-center gap-2">
          <Typography variant="h2" className="mb-2 text-xl" gradient style={{ alignSelf: 'center' }}>
            This page is available only for connected users
          </Typography>
          <Button onClick={connectWallet}>Connect wallet</Button>
        </div>
      </Panel.Wrapper>
    </ErrorLayout>
  )
}
